import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { Route, Switch } from 'react-router-dom';

import buildRoutes from 'routes';

import { useSelector } from 'react-redux';
import AppHelmet from 'components/AppHelmet';
import {
  GlobalStyle,
  Reboot,
  Normalize,
  TableWatermarkGlobalStyles,
} from 'styles';

import { TABLE_WATERMARK_ENABLED } from 'constants/tableWatermark';

import Wrapper from './styles';

const App = memo(() => {
  const currenciesSlug = useSelector(
    ({ routerAdditionalData }) => routerAdditionalData.currencyList
  );
  const citiesList = useSelector(
    ({ routerAdditionalData }) => routerAdditionalData.citiesList
  );

  const routes = useMemo(() => buildRoutes(currenciesSlug, citiesList), [
    currenciesSlug,
    citiesList,
  ]);

  const getRouteRender = useCallback(
    (RouteComponent, routeProps) => routeRenderProps => (
      <RouteComponent {...routeProps} {...routeRenderProps} />
    ),
    []
  );

  const renderRoute = useCallback(
    ({ component, id, props, ...routeProps }) => (
      <Route
        render={getRouteRender(component, props)}
        {...routeProps}
        key={id}
      />
    ),
    []
  );

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    /**
     * Пакет тягне за собою cheerio і важить ~540 КБ, тож вантажимо його
     * окремим чанком уже після гідратації.
     */
    import(/* webpackChunkName: "nofollow" */ '@treeum/nofollow')
      .then(({ nofollow }) => {
        nofollow({ type: 'client', target: document.querySelector('body') });
      })
      .catch(() => {});
  }, []);

  return (
    <Wrapper>
      <AppHelmet />
      <Normalize />
      <Reboot />
      <GlobalStyle />
      {TABLE_WATERMARK_ENABLED && <TableWatermarkGlobalStyles />}
      <Switch>{routes.map(renderRoute)}</Switch>
    </Wrapper>
  );
});

export default App;
